import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'


const DEFAULT_QUESTIONS = [
  {
    text: 'Tu balance mensual',
    question: '¿Cuál fue mi balance en el mes anterior?'
  },
  {
    text: 'Tu saldo de banco',
    question: '¿Cuál es mi saldo de banco?'
  },
  {
    text: 'Las deudas de tus proveedores',
    question: '¿Cuáles fueron las deudas de mis proveedores el mes pasado?'
  },
  {
    text: 'Facturación del año',
    question: '¿Cuánto he facturado este año?'
  },
  {
    text: 'Resumen de ventas',
    question: 'Muéstrame el resumen de mis ventas'
  },
  {
    text: 'Cuentas por cobrar',
    question: '¿Cuánto tengo por cobrar?'
  },
  {
    text: 'Detalle de facturas de ventas',
    question: 'Dame el detalle de mis facturas de ventas'
  },
  {
    text: 'Facturas pendientes',
    question: 'Muéstrame las facturas pendientes de pago'
  },
  {
    text: 'Cuentas por cobrar detalladas',
    question: '¿Cuáles son mis cuentas por cobrar?'
  },
  {
    text: 'Listado de facturas de clientes',
    question: 'Dame el listado de facturas de clientes'
  },
  {
    text: 'Ventas del mes',
    question: '¿Cuánto he vendido este mes?'
  },
  {
    text: 'Gastos del año',
    question: '¿Cuánto he gastado este año?'
  },
  {
    text: 'Resumen de compras',
    question: 'Muéstrame el resumen de mis compras'
  },
  {
    text: 'Cuentas por pagar',
    question: '¿Cuánto tengo por pagar?'
  },
  {
    text: 'Detalle de facturas de compras',
    question: 'Dame el detalle de mis facturas de compras'
  },
  {
    text: 'Facturas pendientes a proveedores',
    question: 'Muéstrame las facturas pendientes de pago a proveedores'
  },
  {
    text: 'Cuentas por pagar detalladas',
    question: '¿Cuáles son mis cuentas por pagar?'
  },
  {
    text: 'Listado de facturas de proveedores',
    question: 'Dame el listado de facturas de proveedores'
  },
  {
    text: 'Gastos del mes',
    question: '¿Cuánto he gastado este mes?'
  },
  {
    text: 'Balance general',
    question: 'Muéstrame el balance general'
  },
  {
    text: 'Balance de 8 columnas',
    question: 'Dame el balance de 8 columnas'
  },
  {
    text: 'Situación financiera actual',
    question: '¿Cuál es mi situación financiera actual?'
  },
  {
    text: 'Balance general del año',
    question: 'Muéstrame el balance general del año actual'
  },
  {
    text: 'Estado de resultados',
    question: 'Muéstrame el estado de resultados'
  },
  {
    text: 'Utilidad del periodo',
    question: '¿Cuál es mi utilidad del periodo?'
  },
  {
    text: 'Estado de resultados del año',
    question: 'Dame el estado de resultados del año actual'
  },
  {
    text: 'Ingresos y gastos',
    question: '¿Cuánto son mis ingresos y gastos?'
  },
  {
    text: 'Estados comparativos',
    question: 'Muéstrame estados de resultados comparativos'
  },
  {
    text: 'Comparación entre periodos',
    question: 'Compara mis resultados entre periodos'
  },
  {
    text: 'Comparación de ingresos y gastos',
    question: 'Dame una comparación de ingresos y gastos'
  },
  {
    text: 'Evolución de resultados',
    question: '¿Cómo han evolucionado mis resultados?'
  },
  {
    text: 'Conciliación de ingresos',
    question: 'Muéstrame la conciliación de ingresos'
  },
  {
    text: 'Conciliación de ventas',
    question: 'Dame la conciliación de ventas'
  },
  {
    text: 'Conciliación de egresos',
    question: 'Muéstrame la conciliación de egresos'
  },
  {
    text: 'Conciliación de compras',
    question: 'Dame la conciliación de compras'
  },
  {
    text: 'Ingresos conciliados',
    question: '¿Cuáles son mis ingresos conciliados?'
  },
  {
    text: 'Egresos conciliados',
    question: '¿Cuáles son mis egresos conciliados?'
  },
  {
    text: 'Dashboard financiero',
    question: 'Muéstrame el dashboard financiero'
  },
  {
    text: 'Facturación neta',
    question: '¿Cuál es mi facturación neta?'
  },
  {
    text: 'Ingresos del mes actual',
    question: '¿Cuánto son mis ingresos del mes actual?'
  },
  {
    text: 'Gastos del mes actual',
    question: '¿Cuánto son mis gastos del mes actual?'
  },
  {
    text: 'Ingresos últimos 3 meses',
    question: 'Dame los ingresos de los últimos 3 meses'
  },
  {
    text: 'Gastos últimos 3 meses',
    question: 'Dame los gastos de los últimos 3 meses'
  },
  {
    text: 'Ingresos anuales',
    question: '¿Cuánto son mis ingresos anuales?'
  },
  {
    text: 'Gastos anuales',
    question: '¿Cuánto son mis gastos anuales?'
  },
  {
    text: 'Saldo acumulado',
    question: '¿Cuál es mi saldo acumulado?'
  },
  {
    text: 'Por pagar y por cobrar',
    question: '¿Cuánto tengo por pagar y por cobrar?'
  },
  {
    text: 'Saldo bancario',
    question: '¿Cuánto tengo en el banco?'
  },
  {
    text: 'Saldo del banco',
    question: '¿Cuál es mi saldo bancario?'
  },
  {
    text: 'Deudas de clientes',
    question: '¿Cuánto me deben los clientes?'
  },
  {
    text: 'Deudas a proveedores',
    question: '¿Cuánto debo a proveedores?'
  },
  {
    text: 'Saldo de IVA',
    question: '¿Cuál es el saldo de IVA?'
  },
  {
    text: 'Total de activos',
    question: '¿Cuánto es el total de activos?'
  },
  {
    text: 'Total de pasivos',
    question: '¿Cuánto es el total de pasivos?'
  },
  {
    text: 'Honorarios por pagar',
    question: '¿Cuál es el saldo de honorarios por pagar?'
  },
  {
    text: 'Ingresos del giro',
    question: '¿Cuánto son mis ingresos del giro?'
  },
  {
    text: 'Gastos totales',
    question: '¿Cuánto son mis gastos totales?'
  },
  {
    text: 'Por tu carpeta tributaria',
    question: 'Muéstrame mi carpeta tributaria'
  }
]

const getQuestionsForPath = (pathname) => {
  const normalizedPath = pathname.toLowerCase()

  if (normalizedPath.includes('facturacion') || normalizedPath.includes('venta') || normalizedPath.includes('cliente')) {
    return DEFAULT_QUESTIONS.filter(q => 
      q.question.toLowerCase().includes('factura') || 
      q.question.toLowerCase().includes('ventas') || 
      q.question.toLowerCase().includes('cobrar') ||
      q.question.toLowerCase().includes('cliente')
    )
  }

  if (normalizedPath.includes('administracion') || normalizedPath.includes('banco') || normalizedPath.includes('proveedor') || normalizedPath.includes('concilia')) {
    return DEFAULT_QUESTIONS.filter(q => 
      q.question.toLowerCase().includes('gastos') || 
      q.question.toLowerCase().includes('compras') || 
      q.question.toLowerCase().includes('pagar') || 
      q.question.toLowerCase().includes('proveedor') ||
      q.question.toLowerCase().includes('banco') ||
      q.question.toLowerCase().includes('concilia')
    )
  }

  if (normalizedPath.includes('reportes') || normalizedPath.includes('micontador') || normalizedPath.includes('ajustes')) {
    return DEFAULT_QUESTIONS.filter(q => 
      q.question.toLowerCase().includes('balance') || 
      q.question.toLowerCase().includes('resultados') || 
      q.question.toLowerCase().includes('utilidad') || 
      q.question.toLowerCase().includes('situación financiera') ||
      q.question.toLowerCase().includes('tributaria')
    )
  }

  return DEFAULT_QUESTIONS
}

const DefaultQuestions = ({ handleSendMessage, onClose, showQuestions, questionKey, questionsRef }) => {
  const location = useLocation()
  const questionsToShow = useMemo(() => {
    const filteredQuestions = getQuestionsForPath(location.pathname)
    const baseQuestions = filteredQuestions.length >= 3 ? filteredQuestions : DEFAULT_QUESTIONS
    const shuffled = [...baseQuestions].sort(() => Math.random() - 0.5)
    return shuffled.slice(0, 3)
  }, [questionKey, location.pathname])


  if (!showQuestions) {
    return null
  }

  return (
    <div ref={questionsRef} className="w-full px-1">
      <div className="relative mb-2 flex items-center justify-center">
        <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-accent2 sm:text-[11px] sm:tracking-[0.16em]">
          Sugerencias rápidas
        </span>
        <button
          type='button'
          aria-label='Cerrar sugerencias rápidas'
          className='absolute right-0 inline-flex h-5 w-5 items-center justify-center rounded-full border border-accent2/20 bg-white text-[11px] font-semibold text-muted transition-colors hover:border-accent2/45 hover:text-text'
          onClick={onClose}
        >
          x
        </button>
      </div>
      <div className="inline-flex w-full flex-wrap items-center justify-center gap-2 pb-0.5 sm:gap-2.5 sm:pb-0">
        {questionsToShow.map((question, index) => (
          <button
            type='button'
            key={`${questionKey}-${index}`}
            className="inline-flex h-auto w-fit min-w-0 max-w-full flex-[0_0_auto] items-center gap-1.5 whitespace-nowrap rounded-full border border-accent2/18 bg-white/95 px-2.5 py-1.5 text-left shadow-[0_8px_18px_rgba(15,23,42,0.05)] transition-all hover:-translate-y-0.5 hover:border-accent2/45 hover:bg-accent2/[0.06] hover:shadow-[0_12px_20px_rgba(28,178,175,0.10)] sm:gap-2 sm:px-3 sm:py-1.5"
            onClick={() => handleSendMessage(question.question)}
            title={question.question}
          >
            <span className="h-2 w-2 shrink-0 rounded-full bg-accent2 shadow-[0_0_0_4px_rgba(28,178,175,0.12)]" />
            <p className="whitespace-nowrap text-[11px] font-semibold leading-none text-text sm:text-[12px]">
              {question.text}
            </p>
          </button>
        ))}
      </div>
    </div>
  )
}

export default DefaultQuestions
